module.exports = __webpack_public_path__ + "static/media/me.76c434a6.svg";